/**
 * @generated SignedSource<<99d611ed162a8971b3fdee62f299754e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsSettingsPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "NotificationsSettingsPage_query";
};
export type NotificationsSettingsPage_query$key = {
  readonly " $data"?: NotificationsSettingsPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationsSettingsPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationsSettingsPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c04175fd91923fc5c2c75c6e28cbf756";

export default node;
